<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <div class="consoleHeader" consoleHeaderOffset
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
        <div class="row flex-nowrap">
            <div class="col-auto header_section pr-2">
                <div
                    *ngIf="masterService.LoggedInUserData.Properties.length > 1"
                    ngbDropdown
                    #ddProperty="ngbDropdown"
                    class="dropdown-noarrow align-self-center"
                    placement="bottom-left"
                    autoClose="outside"
                    (openChange)="onPropertyOpened($event)"
                >
                    <button
                        type="button"
                        class="btn btn-link firstFilter"
                        title="{{'TITLE.TITLE_SELECT_PROPERTIES' | translate}}"
                        ngbDropdownAnchor
                        (click)="$event.stopPropagation(); ddProperty.toggle()"
                        [ngClass]="(RequestModel.Properties.length > 1 ? 'propSelected' : '')"
                    >
                        <i class="ksv-icon-building"></i>
                    </button>
                    <div
                        class="dropdown-menu scrollable-dropdown-menu"
                        ngbDropdownMenu
                    >
                        <div
                            class="dropdown-header"
                            style="padding: 0.5rem 2.75rem"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="IsAllSelected()"
                                [indeterminate]="IsSomeSelected()"
                                (change)="MasterToggle($event)"
                                id="chk_prop_master_glitch"
                            />

                            <label
                                class="form-check-label text-nowrap"
                                for="chk_prop_master_glitch"
                                >{{"LBL.SELECT_PROPERTIES" | translate}}</label
                            >
                        </div>

                        <div class="px-4">
                            <div
                                class="form-check"
                                *ngFor="let row of lstProperties"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="chk_prop_{{row.PropertyId}}"
                                    [value]="row.PropertyId"
                                    [checked]="idxPropSelectedDropDown(row.PropertyId) >= 0"
                                    (change)="onPropertySelected(row.PropertyId, $event)"
                                />
                                <label
                                    class="form-check-label text-nowrap"
                                    for="chk_prop_{{row.PropertyId}}"
                                    >{{row.PropertyName}}</label
                                >
                            </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="px-4">
                            <button
                                class="btn btn-secondary btn-sm"
                                type="button"
                                (click)="onPropertyChange(); ddProperty.close()"
                                translate
                            >
                                BTN.BTN_SAVE
                            </button>
                        </div>
                        <!--<button class="dropdown-item" *ngFor="let row of masterService.LoggedInUserData.Properties" [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}" (click)="RequestModel.PropertyId = row.PropertyId">{{row.PropertyName}}</button>-->
                    </div>
                </div>
            </div>

            <div class="col-auto header_section">
                <div
                    ngbDropdown
                    #ddView="ngbDropdown"
                    class="align-self-center"
                    placement="bottom-left"
                >
                    <div class="d-flex align-items-center">
                        <!--<i class="ksv-icon-views mr-2"></i>-->
                        <a
                            href="javascript:{}"
                            class="btn-nonlink"
                            ngbDropdownToggle
                            >{{'BTN.BTN_MY_VIEW' | translate}}</a
                        >
                    </div>

                    <div class="dropdown-menu" ngbDropdownMenu>
                        <button
                            class="dropdown-item pointer"
                            type="button"
                            (click)="onFilterSave()"
                        >
                            {{'TITLE.TITLE_SAVE_VIEW' | translate}}
                        </button>
                        <button
                            class="dropdown-item pointer"
                            type="button"
                            (click)="onLoadFilter()"
                        >
                            {{'TITLE.TITLE_LOAD_VIEW' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-auto topFilters header_section headerlink-2line">
                <a
                    *ngFor="let row of PropStatModel"
                    [ngClass]="(RequestModel.Status == row.Id ? 'active' : '')"
                    href="javascript:{}"
                    (click)="onTopFilter(row.Id)"
                    class=""
                >
                    <div translate class="topFilter_Label text-center">
                        {{row.Label}}
                    </div>
                    <div class="small text-center">({{row.Value}})</div>
                </a>
            </div>

            <div class="col-auto d-flex align-items-center header_section">
                <div class="searchFilterResult">
                    <input
                        type="text"
                        [placement]="['bottom']"
                        [(ngModel)]="KeywordSearch"
                        [ngbTypeahead]="SearchString"
                        [editable]="false"
                        [resultTemplate]="SearchResult"
                        class="form-control searchFilter_Text"
                        (selectItem)="onSearchFilter($event)"
                        [inputFormatter]="SearchFilter_DisplayText"
                    />
                </div>
            </div>

            <div class="col-auto d-flex align-items-center header_section">
                <div
                    class="w-auto"
                    title="{{'TITLE.TITLE_GROUP_BY' | translate}}"
                >
                    <select
                        class="custom-select"
                        [(ngModel)]="RequestModel.GroupBy"
                        (change)="onGroupingChanged()"
                    >
                        <option
                            *ngFor="let row of GroupTypes"
                            [ngValue]="row.Id"
                        >
                            {{row.Name | uppercase | translate}}
                        </option>
                    </select>
                </div>
                <div class="align-items-center" *ngIf="RequestModel.GroupBy">
                    <div
                        class="ml-4 pointer"
                        (click)="onClearGrouping()"
                        *ngIf="RequestModel.GroupBy"
                    >
                        <strong><i class="fas fa-times fa-lg mr-2"></i></strong
                        >Clear Grouping
                    </div>
                </div>
            </div>

            <div
                class="col-auto d-flex header_section align-items-center px-4"
                [ngClass]="RequestModel.HasFilters ? 'backHightlight':''"
            >
                <div
                    class="pointer"
                    (click)="jobFilter.onOpen(RequestModel)"
                    title="{{'TITLE.TITLE_FILTERS' | translate}}"
                >
                    <i class="fas fa-filter"></i>
                </div>
                <div
                    class="ml-4 pointer"
                    (click)="onClearFilter()"
                    *ngIf="RequestModel.HasFilters"
                >
                    <i class="fas fa-times fa-lg mr-2"></i
                    >{{'TITLE.TITLE_CLEAR_FILTER' | translate}}
                </div>
            </div>

            <div class="col d-flex justify-content-end">
                <div class="header_section align-items-center px-3">
                    <div
                        class="pointer"
                        (click)="OpenKeyModal()"
                        title="{{'TITLE.TITLE_LEGENDS' | translate}}"
                    >
                        <i class="fa fa-lg fa-key fa-fw"></i>
                    </div>
                </div>
                <div class="header_section align-items-center px-3">
                    <div
                        class="pointer"
                        (click)="RefreshData()"
                        title="{{'TITLE.TITLE_REFRESH' | translate}}"
                    >
                        <i class="fa fa-lg fa-sync-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="jobconsole-body">
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <div
            [hidden]="RequestModel.GroupBy != _GlitchSearch_GroupBy.None && !IsSubmitting"
        >
            <GlitchSearchResult
                #grdSearchResult
                [RequestModel]="RequestModel"
                (onSelected)="onSelected($event)"
            >
            </GlitchSearchResult>
        </div>

        <div
            *ngIf="Model != null && RequestModel.GroupBy != _GlitchSearch_GroupBy.None && Model.Result && Model.Result.length > 0"
        >
            <div *ngFor="let row of Model.Result; let index=index;" class="row">
                <div class="col" *ngIf="index<100">
                    <GlitchSearchGroup
                        [RequestModel]="RequestModel"
                        [Model]="row"
                    ></GlitchSearchGroup>
                </div>
            </div>
            <div
                class="d-flex justify-content-center noRecords"
                *ngIf="Model.Result.length >100"
                translate
            >
                LBL.DISCLAIMER_GROUPING_LIMIT
            </div>
        </div>
        <div
            *ngIf="Model != null && RequestModel.GroupBy != _GlitchSearch_GroupBy.None && Model.Result == null && !IsSubmitting"
            class="noRecords"
        >
            <span translate>LBL.NO_RECORD_FOUND</span>
        </div>
    </div>
</div>

<ng-template #SearchResult let-row="result" let-t="term" class="">
    <div class="d-flex justify-content-between align-items-center">
        <div class="w-auto d-flex align-items-center">
            <div
                class="w-auto mr-2"
                title="{{'TITLE.TITLE_SEARCH' | translate}}"
            >
                <div class="searchIcon"><i class="fas fa-search"></i></div>
            </div>
            <div class="w-auto mr-2">{{t}}</div>
        </div>
        <div class="w-auto">
            <div class="entityName text-muted">
                {{'ENTITIES.ENTITIES_' + row.EntityName | uppercase |
                translate}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #glConsoleKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard glitchstatus-true"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_OPEN_GLITCH</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-briefcase"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GUEST</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard glitchstatus-false border-0"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CLOSED_GLITCH
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="ic-status active col-1">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GUEST_VIP</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-map-marker-alt"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_INCIDENT_LOCATION
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-paperclip"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_ATTACHMENT</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-lock-open"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_REG_DATE_TIME
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="ic-status active col-1">
                    <i class="fas fa-lock-open"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_REG_DATE_TIME_REOPEN_GLITCH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-building"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_PROPERTY</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-filter"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_GLITCH_FILTER
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="ksv-icon-reset-job"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_INCIDENT_DATE_TIME
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="far fa-fw fa-eye"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_INVESTIGATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-percentage"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_RECOVERY</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard glitchstatus-dup"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_DUPLICATE_GLITCH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <!-- <div class="col-1 gsrEnabled">
                    <i class="fas fa-clipboard-check"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GSR</div> -->
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_REFRESH</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-sort"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_SORT</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-lock"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CLOSED_DATE_TIME
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-user"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_STAFF_GLITCH</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-off statusIcon-Error"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_FAIL
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-bell"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_NOTIFICATION</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-on statusIcon-Sucess"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_SUCCESS
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="ksv-icon-expand"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_EXPAND</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1 usr-info">
                    <i class="fas fa-info-circle"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_USR_INFO</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <i class="icon-html-icons_collapse"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_COLLAPSE</div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary mr-3"
            (click)="c('close')"
            translate
        >
            BTN.BTN_OK
        </button>
    </div>
</ng-template>

<GlitchPopover
    #glitchPopover
    [Selected]="glitchService._SelectedGlitch"
></GlitchPopover>
<JobFilter
    #jobFilter
    (ApplyFilter)="SetData()"
    [EnabledFilters]="EnabledFilters"
></JobFilter>
<RegisterGlitch
    *ngIf="CheckAuth_Action(_AuthActionCodes.GlitchRegistration)"
    [DisplayMode]="2"
></RegisterGlitch>
